import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataObject } from '../../interfaces/data-objects';

@UntilDestroy()
@Component({
  selector: 'iv-multiselect-autocomplete',
  templateUrl: './multiselect-autocomplete.component.html',
  styleUrls: ['./multiselect-autocomplete.component.scss'],
})
export class MultiselectAutocompleteComponent implements OnInit {
  // Required props list, key, inputValCtrl!!
  @Input() list: any[] = [];
  @Input() key = ''; // the prop on list of objects which will be shown in autocomplete list
  @Input() multiSelectCtrl: UntypedFormControl;
  @Input() areAllSelected: UntypedFormControl;
  @Input() selectAll = false;
  @Input() placeHolderLabel: string;
  @Input() noEntriesFoundLabel: string;
  @Input() selectedValues;
  @Input() elementId;
  @Input() data: DataObject;
  @Input() label: string = '';

  public filterInputCtrl: UntypedFormControl = new UntypedFormControl();
  public filteredList: DataObject[] = [];
  isIndeterminate = false;
  isChecked = false;
  public filteredMultiList: ReplaySubject<object[]> = new ReplaySubject<object[]>(1);
  // public tooltipMessage = 'Select All / Unselect All';
  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;

  constructor() { }

  ngOnInit() {
    this.filteredList = this.list.slice();
    this.filteredMultiList.next(this.list);
    if (this.filterInputCtrl) {
      this.filterInputCtrl.valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.filterList();
          this.setToggleAllCheckboxState();
        });
    }
    if (this.multiSelectCtrl) {
      this.multiSelectCtrl.valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.setToggleAllCheckboxState();
        });
    }
  }

  // TODO: If needed we need logic change here
  toggleSelectAll(selectAllValue: boolean) {
    this.filteredMultiList
      .pipe(untilDestroyed(this), take(1))
      .subscribe((val) => {
        if (selectAllValue) {
          this.multiSelectCtrl.patchValue(val);
          this.areAllSelected.setValue(true);
        } else {
          this.multiSelectCtrl.patchValue([]);
          this.areAllSelected.setValue(false);
        }
      });
  }

  protected filterList() {
    if (!this.list) {
      return;
    }
    // get the search keyword
    let search = this.filterInputCtrl.value;
    if (!search) {
      this.filteredList = this.list.slice();
      this.filteredMultiList.next(this.filteredList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the list
    this.filteredList = this.list.filter(
      (val) => val[this.key].toLowerCase().indexOf(search) > -1
    );
    this.filteredMultiList.next(this.filteredList);
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.multiSelectCtrl && this.multiSelectCtrl?.value) {
      this.filteredList.forEach((el) => {
        if (this.multiSelectCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredList.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredList.length;

      if (this.isIndeterminate) {
        this.areAllSelected.setValue(false);
      }
      if (this.isChecked) {
        this.areAllSelected.setValue(true);
      }
    }
  }

  compareObjects(o1: any, o2: any) {
    if (o1?.value === o2?.value && o1?.label === o2?.label) {
      return true;
    } else {
      return false;
    }
  }

}
